// eslint-disable-next-line import/prefer-default-export
export const CATEGORY_NAMES = {
  CMSA: 'CMSA',
}
